import { takeEvery, put, call } from "redux-saga/effects"

// Chat Redux States
import { GET_SHEET, ADD_NEW_SHEET } from "./actionTypes"

//Include Both Helper File with needed methods
import { getSheet, addSheet } from "../../helpers/order_sheet_be_helper"
import { resetSheetDatas, storeImageList, storeSheetDatas } from "./action"
import Listener from "../../helpers/Listen"

function* getSheets(params) {
  try {
    const response = yield call(getSheet, params.payload)
    if (response.data === "") {
      return
    }
    yield put(storeSheetDatas(response.data))
  } catch (error) {
    // yield put(addMessageFail(error));
  }
}

function* addSheets(params) {
  try {
    const files = params.payload.files ?? null
    const id = params.payload.id
    const jsonArr = params.payload.jsonCanvas ?? []

    const formData = new FormData()
    formData.append(
      "numberOfPages",
      params.payload.jsonCanvas ? params.payload.jsonCanvas.length : 1
    )

    if (files) {
      for (let i = 0; i < files.length; i++) {
        formData.append(`files`, files[i])
      }
    }
    if (jsonArr) {
      for (let i = 0; i < jsonArr.length; i++) {
        formData.append(`jsonArray[${i}]`, JSON.stringify(jsonArr[i]))
      }
    }
    const response = yield call(addSheet, { formData, id })
    if (files) {
      yield put(storeSheetDatas(response.data))
    } else {
      yield put(resetSheetDatas)
      Listener.emit("back", "success")
    }
  } catch (error) {
    // yield put(addMessageFail(error));
  }
}

function* chatSaga() {
  yield takeEvery(GET_SHEET, getSheets),
    yield takeEvery(ADD_NEW_SHEET, addSheets)
}

export default chatSaga
